import HomePage from 'components/organisms/HomePage/HomePage';
import React from 'react';

export default function Home() {
  document.body.style.overflow = '';
  return <HomePage />;
}
